import { NavigationLinkProps } from './TabNav';

export const initialNavigationLinkConfig: NavigationLinkProps = {
  title: '',
  value: '',
  url: '',
};

/*
 * All tab configs for Products Analyzer
 */
export enum ProductsTabView {
  Overview = 'overview',
  Leaderboard = 'leaderboard',
  Trends = 'trends',
}

export enum ProductsTabTitle {
  Overview = 'Overview',
  Leaderboard = 'Leaderboard',
  Trends = 'Trends',
}

export enum ProductsTabUrl {
  Overview = 'overview',
  Leaderboard = 'leaderboard',
  Trends = 'trends',
}

export const overViewLink = {
  title: ProductsTabTitle.Overview,
  value: ProductsTabView.Overview,
  url: ProductsTabUrl.Overview,
};
export const leaderboardLink = {
  title: ProductsTabTitle.Leaderboard,
  value: ProductsTabView.Leaderboard,
  url: ProductsTabUrl.Leaderboard,
};
export const trendsLink = {
  title: ProductsTabTitle.Trends,
  value: ProductsTabView.Trends,
  url: ProductsTabUrl.Trends,
};
export const productsLinkConfig: NavigationLinkProps[] = [overViewLink, trendsLink, leaderboardLink];

export enum TradingAssistantTabTitle {
  SupplierReview = 'Supplier Review',
}

export enum TradingAssistantTabView {
  SupplierReview = 'supplier-review',
}

export enum TradingAssistantTabUrl {
  SupplierReview = 'supplier-review',
}

export const supplierReviewLink = {
  title: TradingAssistantTabTitle.SupplierReview,
  value: TradingAssistantTabView.SupplierReview,
  url: TradingAssistantTabUrl.SupplierReview,
};

/*
 * All tab configs for Explore page
 */
export enum ExploreTabView {
  Leaderboard = 'leaderboard',
  Trends = 'trends',
  Segments = 'segments',
}

export enum ExploreTabTitle {
  Leaderboard = 'Leaderboard',
  Trends = 'Trends',
  Segments = 'Segments',
}

export enum ExploreTabUrl {
  Leaderboard = 'leaderboard',
  Trends = 'trends',
  Segments = 'segments',
}

export const exploreSegmentsLink = {
  title: ExploreTabTitle.Segments,
  value: ExploreTabView.Segments,
  url: ExploreTabUrl.Segments,
};
export const exploreLeaderboardLink = {
  title: ExploreTabTitle.Leaderboard,
  value: ExploreTabView.Leaderboard,
  url: ExploreTabUrl.Leaderboard,
};
export const exploreTrendsLink = {
  title: ExploreTabTitle.Trends,
  value: ExploreTabView.Trends,
  url: ExploreTabUrl.Trends,
};

export const explorLinkConfig: NavigationLinkProps[] = [exploreLeaderboardLink, exploreTrendsLink, exploreSegmentsLink];
